export const device = {
  mobile320: "320px",
  mobile375: "375px",
  mobile425: "425px",
  tablet768: "768px",
  laptop1024: "1024px",
  laptop1440: "1440px",
  desktop2560: "2560px",
};
